module.exports = __webpack_public_path__ + "img/ic-color-cc.b96ed643.svg";